export const formatPostalCode = (cep) => {
  const digits = String(cep || '').replace(/\D/g, '');
  if (digits.length !== 8) return cep || '';
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
};

export const buildShippingAddressFromCheckout = (checkoutShipping, stripeAddress = null) => {
  if (!checkoutShipping) return stripeAddress || null;

  const digits = String(checkoutShipping.cep || checkoutShipping.postalCode || '').replace(/\D/g, '');
  const street = String(checkoutShipping.street || '').trim();
  const number = String(checkoutShipping.number || '').trim();
  const complement = String(checkoutShipping.complement || '').trim();
  const neighborhood = String(checkoutShipping.neighborhood || '').trim();
  const city = String(checkoutShipping.city || '').trim();
  const state = String(checkoutShipping.state || '').trim();

  const addr = {
    ...(stripeAddress || {}),
    country: 'BR',
  };

  if (digits) addr.postalCode = digits;
  if (city) addr.city = city;
  if (state) addr.state = state;
  if (neighborhood) addr.neighborhood = neighborhood;

  if (street && number) {
    addr.line1 = `${street}, ${number}`;
    addr.number = number;
  } else if (street) {
    addr.line1 = street;
  } else if (number) {
    addr.line1 = `Nº ${number}`;
    addr.number = number;
  }

  if (complement) {
    addr.line2 = complement;
  }

  const hasContent = addr.line1 || addr.line2 || addr.city || addr.state || addr.postalCode;
  return hasContent ? addr : stripeAddress || null;
};

export const formatShippingAddressLines = (addr) => {
  if (!addr) return null;

  const lines = [];

  if (addr.line1) {
    let line = addr.line1;
    if (addr.number && !line.includes(addr.number)) {
      line = `${line}, ${addr.number}`;
    }
    lines.push(line);
  } else if (addr.number) {
    lines.push(`Nº ${addr.number}`);
  }

  if (addr.line2) lines.push(addr.line2);

  if (addr.neighborhood) lines.push(addr.neighborhood);

  if (addr.city || addr.state) {
    lines.push([addr.city, addr.state].filter(Boolean).join(' — '));
  }

  if (addr.postalCode) {
    lines.push(`CEP: ${formatPostalCode(addr.postalCode)}`);
  }

  if (lines.length === 0 && addr.postalCode) {
    lines.push(`CEP: ${formatPostalCode(addr.postalCode)}`);
  }

  return lines.length ? lines : null;
};
